export function getSaleUnitQuantity(value) {
  const quantity = Number(value);
  return Number.isSafeInteger(quantity) && quantity > 0 ? quantity : 1;
}

export function getReportableStock(physicalStock, saleUnitQuantity = 1) {
  const stock = Number(physicalStock);
  return Math.floor(Math.max(0, Number.isFinite(stock) ? stock : 0) / getSaleUnitQuantity(saleUnitQuantity));
}

export function parseSaleUnitQuantity(value) {
  const normalized = String(value ?? '').trim();
  if (!/^\d+$/.test(normalized)) return null;
  const quantity = Number(normalized);
  return Number.isSafeInteger(quantity) && quantity > 0 ? quantity : null;
}

export function formatUnits(quantity) {
  return `${quantity} ${quantity === 1 ? 'unidad' : 'unidades'}`;
}
